'use client';

import {
  Dialog,
  DialogActionButton,
  DialogCloseButton,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogSubTitle,
  DialogTitle,
} from '@pickleballinc/ui/components/ui/dialog-v2';

interface UnfriendConfirmModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

export function UnfriendConfirmModal({ open, onOpenChange, onConfirm }: UnfriendConfirmModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className='!max-w-[400px]'>
        <DialogHeader>
          <DialogTitle>Unfriend this player?</DialogTitle>
          <DialogSubTitle>
            Unfriending this player will remove them from your friends list. You can send them a
            friend request again at any time.
          </DialogSubTitle>
        </DialogHeader>
        <DialogFooter>
          <DialogCloseButton>Cancel</DialogCloseButton>
          <DialogActionButton onClick={onConfirm}>Confirm</DialogActionButton>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
